import React from "react";
import {IProduct} from 'data/interfaces/products';
import HotelImageSquare from '../hotelImageSquare';
import {flightCompanyToLogoUrl} from 'gui/components/listPage/components/ad/components/airlineImageSquare/AirlineImageSquare';

export interface IVacationImageSquare {
  product: IProduct;
  className?: string;
  iconContainerClassName?: string;
  children?: any;
}


const VacationInfoSquare = (props: IVacationImageSquare) => (
  <HotelImageSquare
    product={props.product}
    className={props.className}
    iconContainerClassName={props.iconContainerClassName}
    label="חופשה"
    logoSrc={flightCompanyToLogoUrl(props.product.ticketDetails.originFlightCompany)}
    logoTitle={props.product.ticketDetails.originFlightCompany.name}
    {...props}
  />
);

VacationInfoSquare.defaultProps = {};

export default VacationInfoSquare;
